import React from 'react';
import '../../../styles/global.css';

function DanceDanceFish() {
  return (
    <div className="body-container">
      <h1>Dance Dance Fish</h1>
      <h4>Feb 2021</h4>
      <p>A fish dancing under the ocean.</p>
      <p>Modeling, Shading, Rigging, Animation done in Autodesk Maya.</p>
      <h3>Animation:</h3>
      <video src={require('./assets/dance_dance_fish.mp4')} controls>
        <source src={require("./assets/dance_dance_fish.mp4")} type="video/mp4" />
      </video>

      <h3>Character Design:</h3>
      <img src={require('./assets/fish-design.png')} />
    </div>
  );
};

export default DanceDanceFish;
